import React, { useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import { Url } from "../../config/config";
import Modal from "react-bootstrap/Modal";
import useButtonLoader from "../../hooks/useButtonLoader";
import useFullPageLoader from "../../hooks/useFullPageLoader";

export default function FinancialPartnerType() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [BlockModal, setBlockModal] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [inputField, setInputField] = useState({
    status: true,
    id: "",
    financeCompanyType: "",
  });

  const { status, id, financeCompanyType } = inputField;

  const [errorField, setErrorField] = useState({
    financeCompanyType: "",
  });
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  //********************Partner List***************************************** */
  const financialPartnerList = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/financialPartner?page=${page}&search=${query}`,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();
      if (res.status === 200) {
        setRecord(res.data.data.typeList);
        setTotal(res.data.data.total);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  //******************Handel update status*********************************** */

  const handleChecked = (e, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: e.target.checked,
      id: id,
    });
  };

  const handelBlockClose = () => {
    setBlockModal(false);
  };
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const handelUpdateStatus = async () => {
    try {
      let res = await axios({
        url: `${Url}/financialPartner/status`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          typeId: id,
          status: status,
        },
      });
      handelBlockClose();
      toast.success(res.data.message);
      financialPartnerList();
    } catch (err) {
      console.log(err);
    }
  };

  //************************Handel Add Action************************** */
  const [AddModal, setAddModal] = useState(false);
  const handelAddModalShow = () => {
    setInputField({ ...inputField, financeCompanyType: "" });
    setAddModal(true);
  };

  const handelAddModalClose = () => {
    setAddModal(false);
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    //console.log("input handler", name, "     ", value);
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!inputField.financeCompanyType) {
      errorField["financeCompanyType"] = "This field is required";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };

  const handelSubmit = async () => {
    try {
      if (handleValidation()) {
        setSubmitLoading(true);
        let res = await axios({
          url: `${Url}/financialPartner`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: { financeCompanyType: financeCompanyType },
        });
        setSubmitLoading(false);
        if (res.data.status === 200) {
          handelAddModalClose();
          setInputField("");
          setErrorField("");
          financialPartnerList(1);
          toast.success(res.data.message);
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***************************Handel Edit Action********************************* */
  const [EditModal, setEditModal] = useState(false);
  const handelEditModalClose = () => {
    setEditModal(false);
  };
  const handelEditModalShow = (data) => {
    setInputField({
      ...inputField,
      id: data._id,
      financeCompanyType: data.financeCompanyType,
    });
    setEditModal(true);
  };

  const handelEditSubmit = async () => {
    try {
      let res = await axios({
        url: `${Url}/financialPartner`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        data: { typeId: id, financeCompanyType: financeCompanyType },
      });
      if (res.data.status === 200) {
        handelEditModalClose();
        setErrorField("");
        financialPartnerList(1);
        toast.success(res.data.message);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went to wrong");
    }
  };

  //**********************Handel Delete Action********************************************* */
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/financialPartner?typeId=${id}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        financialPartnerList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    financialPartnerList(1);
  }, []);

  //**********************Handel Pagination OnChange */
  const handlePageChange = (event) => {
    setActivePage(event);
    financialPartnerList(event);
  };

  //********************Handel Search**************************** */
  const handelSearch = (e) => {
    financialPartnerList(activePage, e.target.value);
  };

  return (
    <React.Fragment>
      <title>Partner Category Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />

              <button className="button" type="button py-auto" onClick={handelAddModalShow}>
                Add&nbsp;Category
              </button>
            </div>
            <h4 className="Title">Partner Category Management</h4>
            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Financial Partner Name</th>
                    <th>Status</th>
                    <th>action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{++i}</td>

                        <td>{item.financeCompanyType}</td>

                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <span
                            className="Green inline-block"
                            onClick={(e) => handelEditModalShow(item)}
                          >
                            <i className="fa fa-edit"></i>
                          </span>

                          <span
                            className="Red inline-block"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Add modal */}
        <Modal
          show={AddModal}
         
          onHide={handelAddModalClose}
        >
          <Modal.Header closeButton onClick={handelAddModalClose}>
            <Modal.Title>Partner Category Partner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Types Of Financial Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Types Of Financial Name"
                  name="financeCompanyType"
                  value={financeCompanyType}
                  onChange={handleInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.financeCompanyType}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handelAddModalClose}>
              Close
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End add Modal */}

        {/* Edit modal */}
        <Modal
          show={EditModal}
         
          onHide={handelEditModalClose}
        >
          <Modal.Header closeButton onClick={handelEditModalClose}>
            <Modal.Title>Partner Category Partner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Types Of Financial Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Types Of Financial Name"
                  name="financeCompanyType"
                  value={financeCompanyType}
                  onChange={handleInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.financeCompanyType}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
         {/*  <button variant="secondary" onClick={handelEditModalClose}>
              Close
            </button> */}
            <button className="primary" variant="primary" onClick={handelEditSubmit}>
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End edit Modal */}

        {/* Start Delete Modal */}
        <Modal
          show={DeleteModal}
         
          onHide={handelDeleteClose}
        >
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure want to delete this financial type?
          </Modal.Body>
          <Modal.Footer>
            <button className="primary" variant="secondary" onClick={handelDeleteClose}>
              No
            </button>
            <button className="secondary" variant="primary" onClick={handelDelete}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}

        {/* block or unblock model */}
        <Modal
          show={BlockModal}
         
          onHide={handelBlockClose}
        >
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handelBlockClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={handelUpdateStatus}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}
      </div>
    </React.Fragment>
  );
}
